"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[88115],{

/***/ 98899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49288);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  cursor: auto;\n\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  margin: ",
        ";\n  padding: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        filterOption: false,
        dropdownStyle: {
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset"
        },
        margin: props.margin,
        width: props.width || "100%",
        padding: props.padding,
        mt: props.mt,
        mb: props.mb,
        ml: props.ml,
        mr: props.mr,
        pt: props.pt,
        pb: props.pb,
        pl: props.pl,
        pr: props.pr
    };
}).withConfig({
    componentId: "sc-3205d83e-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var mt = param.mt;
    return mt;
}, function(param) {
    var mb = param.mb;
    return mb;
}, function(param) {
    var ml = param.ml;
    return ml;
}, function(param) {
    var mr = param.mr;
    return mr;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var pt = param.pt;
    return pt;
}, function(param) {
    var pb = param.pb;
    return pb;
}, function(param) {
    var pl = param.pl;
    return pl;
}, function(param) {
    var pr = param.pr;
    return pr;
}));


/***/ }),

/***/ 78587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Antd Modal */\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-color: ",
        ";\n  }\n  .ant-modal-content {\n    border-radius: 4px;\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-81e0fb4c-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 52211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* reexport safe */ _Select__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   "iA": function() { return /* reexport safe */ _Table__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "kO": function() { return /* reexport safe */ _AutoSuggestion__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "zx": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89999);
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8150);
/* harmony import */ var _AutoSuggestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98899);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61166);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78587);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48469);









/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 55872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74673);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92182);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35921);





function PaywallWidget(param) {
    var height = param.height, source = param.source;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var widget = param.widget;
        return {
            isLoading: widget.isLoading,
            isRenewal: widget.isRenewal
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isLoading = ref.isLoading, isRenewal = ref.isRenewal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .WidgetWrapper */ .wv, {
        height: height,
        children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            source: source,
            isRenewal: isRenewal,
            height: "100%",
            isWidget: true
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWidget);


/***/ }),

/***/ 71078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29658);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var InfiniteScroll = function(_param) {
    var children = _param.children, hasMore = _param.hasMore, refineNext = _param.refineNext, loader = _param.loader, isLoading = _param.isLoading, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "hasMore",
        "refineNext",
        "loader",
        "isLoading"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), sentinel = ref[0], setSentinel = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), observer = ref1[0], setObserver = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onSentinelIntersection = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && hasMore) {
                    refineNext();
                }
            });
        };
        if (hasMore) {
            setObserver(new window.IntersectionObserver(onSentinelIntersection));
        }
    }, [
        hasMore,
        refineNext
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (observer && sentinel) {
            observer.observe(sentinel);
        }
        return function() {
            if (observer && sentinel) observer.disconnect();
        };
    }, [
        observer,
        sentinel
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                condition: loader && isLoading && hasMore,
                children: loader
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                condition: !isLoading && observer && hasMore,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        display: "inline"
                    },
                    className: "infinite-sentinel",
                    ref: function(c) {
                        return setSentinel(c);
                    }
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);


/***/ }),

/***/ 46880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideWidget_RunningTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Widget.tsx
var Widget = __webpack_require__(55872);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/constants/datafeed.ts
var datafeed = __webpack_require__(33714);
// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedAuthEffect.ts
var useDatafeedAuthEffect = __webpack_require__(39834);
// EXTERNAL MODULE: ./src/global/Datafeed/store/runningTrade/index.ts + 2 modules
var store_runningTrade = __webpack_require__(11453);
// EXTERNAL MODULE: ./src/global/Datafeed/index.tsx + 1 modules
var Datafeed = __webpack_require__(87637);
;// CONCATENATED MODULE: ./src/global/Datafeed/useDatafeedMessage.ts


var useDatafeedMessage = function(channel, key, callbackFn) {
    var setAction = (0,react.useContext)(Datafeed/* DatafeedContext */.y).setAction;
    var actionSet = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (actionSet.current) return;
        actionSet.current = true;
        setAction(channel, key, callbackFn);
    }, []);
};
/* harmony default export */ var Datafeed_useDatafeedMessage = (useDatafeedMessage);

// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedSocket.ts
var useDatafeedSocket = __webpack_require__(92924);
;// CONCATENATED MODULE: ./src/global/Datafeed/useRunningTrade.ts













var useRunningTrade = function(key, customFilter) {
    var ref = (0,useDatafeedSocket/* default */.Z)(), setChannel = ref.setChannel, isAuthorized = ref.isAuthorized;
    var addBatch = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.addBatch;
    });
    var shiftBatch = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.shiftBatch;
    });
    var setIsQueue = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setIsQueue;
    });
    var setActive = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setActive;
    });
    var setFilter = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setFilter;
    });
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var play = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.play;
    });
    var runningTradeInstance = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.runningTrade[key];
    });
    var runningTradeAllFilter = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        var dataReduced = Object.entries(state.runningTrade).reduce(function(prev, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), itemKey = _param[0], itemValue = _param[1];
            return (0,_object_spread/* default */.Z)({}, prev, itemValue.filter !== "" ? (0,_define_property/* default */.Z)({}, itemKey, itemValue.filter) : {});
        }, {
            company: "",
            widget: ""
        });
        if (dataReduced && dataReduced.company && dataReduced.widget && dataReduced.widget === "*") {
            delete dataReduced.company;
        }
        return dataReduced;
    }, shallow/* default */.Z);
    var ref1 = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return {
            isQueue: state.runningTrade[key].isQueue,
            isActive: state.runningTrade[key].isActive,
            isPaused: state.runningTrade[key].isPaused
        };
    }, shallow/* default */.Z), isQueue = ref1.isQueue, isActive = ref1.isActive, isPaused = ref1.isPaused;
    // getting non-reactive running trade instance
    var getRunningTradeInstance = function() {
        return store_runningTrade/* useRunningTradeStore.getState */.C.getState().runningTrade[key];
    };
    var getStockByFilter = function(newFilter) {
        if (runningTradeAllFilter && runningTradeAllFilter.company && runningTradeAllFilter.widget && runningTradeAllFilter.widget === "*") {
            delete runningTradeAllFilter.company;
            return Object.values((0,_object_spread/* default */.Z)({}, runningTradeAllFilter));
        }
        return Object.values((0,_object_spread/* default */.Z)({}, runningTradeAllFilter, newFilter !== undefined && (0,_define_property/* default */.Z)({}, key, newFilter)));
    };
    var setQueueInstanceBatch = function() {
        /** Recursive function not getting updated values,
     * with that we need to directly get value from store using getState() */ var instance = getRunningTradeInstance();
        if (!instance.isQueue || !instance.isActive || instance.isPaused) return;
        setIsQueue(key);
        shiftBatch(key);
        setTimeout(function() {
            return setQueueInstanceBatch();
        }, 1000 / datafeed/* runningTradeConfig.widget.speed */.x.widget.speed);
    };
    /** Send empty string to stop running trade */ var setInstanceFilter = function(value) {
        clearData(key);
        setFilter(key, value);
        setChannel({
            runningTradeBatch: getStockByFilter(value)
        });
    };
    var setDebounceInstanceFilter = lodash_debounce_default()(setInstanceFilter, 200);
    var setInstanceQueue = function() {
        setIsQueue(key);
    };
    var setInstanceActive = function(value) {
        setActive(key, value);
        setInstanceQueue();
        play(key);
    };
    var handleReceiveMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var instance, runningTradeBatch, error, ref, _batch, batch, filteredBatch;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        instance = getRunningTradeInstance();
                        if (instance.isActive) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        runningTradeBatch = message.runningTradeBatch, error = message.error;
                        ref = runningTradeBatch || {}, _batch = ref.batch, batch = _batch === void 0 ? [] : _batch;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw error;
                    case 7:
                        filteredBatch = batch;
                        if (customFilter) {
                            filteredBatch = customFilter(batch);
                        }
                        if (filteredBatch.length > 0) {
                            addBatch(key, filteredBatch);
                            if (instance.isActive && !instance.isQueue) setInstanceQueue();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReceiveMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useDatafeedAuthEffect/* default */.Z)(function() {
        if (isActive) {
            setChannel({
                runningTradeBatch: Object.values(runningTradeAllFilter)
            });
        }
    }, [
        runningTradeAllFilter
    ]);
    Datafeed_useDatafeedMessage("runningTradeBatch", key, handleReceiveMessage);
    (0,react.useEffect)(function() {
        if (isQueue || isPaused) setQueueInstanceBatch();
    }, [
        isQueue,
        isPaused
    ]);
    return {
        runningTrade: runningTradeInstance,
        setInstanceActive: setInstanceActive,
        setInstanceFilter: setInstanceFilter,
        setDebounceInstanceFilter: setDebounceInstanceFilter,
        isLoading: !isAuthorized,
        runningTradeAllFilter: runningTradeAllFilter
    };
};
/* harmony default export */ var Datafeed_useRunningTrade = (useRunningTrade);

// EXTERNAL MODULE: ./src/global/Loading/PrimarySpinner.tsx
var PrimarySpinner = __webpack_require__(32253);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/Failed.tsx
var Failed = __webpack_require__(6396);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/styled.ts
var styled = __webpack_require__(6775);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/Header.tsx





var Header = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* HeaderContainer */.gM, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "16px",
            family: "bold",
            children: children
        })
    });
};
Header.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var RunningTrade_Header = (Header);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeTable.tsx
var RunningTradeTable = __webpack_require__(51725);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/useRunningTradeInit.ts
var useRunningTradeInit = __webpack_require__(64577);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeInitTable.tsx + 1 modules
var RunningTradeInitTable = __webpack_require__(61185);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/PausePlay.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 10px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2px;\n  border-radius: 14px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c076f929-0"
})(_templateObject(), color/* default.downgray */.Z.downgray, color/* default.light */.Z.light);
var PlayIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/rt-play.svg",
        alt: "Play"
    });
};
var PauseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/rt-pause.svg",
        alt: "Pause"
    });
};
var PausePlay = function() {
    var isPaused = (0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return s.runningTrade.widget.isPaused;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return [
            s.pause,
            s.play, 
        ];
    }), 2), pause = ref[0], play = ref[1];
    var onClickButton = function() {
        if (isPaused) {
            play("widget");
        } else {
            pause("widget");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
        onClick: onClickButton,
        children: [
            isPaused ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PauseIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                weight: "700",
                width: "34px",
                size: "12px",
                color: color/* default.highgray */.Z.highgray,
                children: isPaused ? "Play" : "Pause"
            })
        ]
    });
};
/* harmony default export */ var ActionControl_PausePlay = (PausePlay);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Checkbox.js
var Checkbox = __webpack_require__(81190);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 16px 10px 16px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #f6f6f6;\n\n      #rt-filter-chevron-down {\n        transform: rotate(180deg);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 4px;\n  align-items: center;\n  gap: 4px;\n  border-radius: 14px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 3px;\n  min-width: 318px;\n  position: absolute;\n  top: 90px;\n  right: 40px;\n  background: ",
        ";\n  width: 318px;\n  z-index: 999;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: ",
        ";\n  }\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n    width: 18px;\n    height: 18px;\n    position: relative;\n\n    :after {\n      left: 3.5px !important;\n      top: 7px !important;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n  .ant-checkbox-disabled .ant-checkbox-inner {\n    border-color: ",
        "!important;\n    background-color: ",
        ";\n  }\n  .ant-checkbox {\n    top: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var ActionControlWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-869f0aa3-0"
})(styled_templateObject());
var ButtonDropdownTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-869f0aa3-1"
})(_templateObject2(), color/* default.downgray */.Z.downgray, color/* default.light */.Z.light, function(param) {
    var isOpened = param.isOpened;
    return isOpened && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-869f0aa3-2"
})(_templateObject3(), color/* default.light */.Z.light);
var styled_Checkbox = (0,styled_components_browser_esm/* default */.ZP)(Checkbox/* default */.Z).withConfig({
    componentId: "sc-869f0aa3-3"
})(_templateObject4(), color/* default.lowgray */.Z.lowgray, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.lowgray */.Z.lowgray, color/* default.lowgray */.Z.lowgray);

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 54 modules
var date_picker = __webpack_require__(35851);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/devWarning.js
var devWarning = __webpack_require__(21687);
;// CONCATENATED MODULE: ./node_modules/antd/es/time-picker/index.js


var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




var InternalTimePicker = date_picker/* default.TimePicker */.Z.TimePicker,
    InternalRangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var RangePicker = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/react.createElement(InternalRangePicker, (0,esm_extends/* default */.Z)({}, props, {
    dropdownClassName: props.popupClassName,
    picker: "time",
    mode: undefined,
    ref: ref
  }));
});
var TimePicker = /*#__PURE__*/react.forwardRef(function (_a, ref) {
  var addon = _a.addon,
      renderExtraFooter = _a.renderExtraFooter,
      popupClassName = _a.popupClassName,
      restProps = __rest(_a, ["addon", "renderExtraFooter", "popupClassName"]);

  var internalRenderExtraFooter = react.useMemo(function () {
    if (renderExtraFooter) {
      return renderExtraFooter;
    }

    if (addon) {
      (0,devWarning/* default */.Z)(false, 'TimePicker', '`addon` is deprecated. Please use `renderExtraFooter` instead.');
      return addon;
    }

    return undefined;
  }, [addon, renderExtraFooter]);
  return /*#__PURE__*/react.createElement(InternalTimePicker, (0,esm_extends/* default */.Z)({}, restProps, {
    dropdownClassName: popupClassName,
    mode: undefined,
    ref: ref,
    renderExtraFooter: internalRenderExtraFooter
  }));
});
TimePicker.displayName = 'TimePicker';
TimePicker.RangePicker = RangePicker;
/* harmony default export */ var time_picker = (TimePicker);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/types.ts
var types = __webpack_require__(7365);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/constants.ts

var actionTypeMenus = [
    {
        label: "All",
        key: types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL
    },
    {
        label: "Buy",
        key: types/* RunningTradeCustomFilterActionEnum.BUY */.Q.BUY
    },
    {
        label: "Sell",
        key: types/* RunningTradeCustomFilterActionEnum.SELL */.Q.SELL
    }, 
];
var predefinedLot = [
    {
        label: "100",
        value: 100
    },
    {
        label: "200",
        value: 200
    },
    {
        label: "500",
        value: 500
    },
    {
        label: "1000",
        value: 1000
    }, 
];

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/store.ts
var store = __webpack_require__(78970);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/styled.ts

function AdvancedFilter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 14px 8px;\n  height: 451px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"
    ]);
    AdvancedFilter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    > p {\n      color: ",
        ";\n      font-weight: 700;\n    }\n  "
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 15px;\n  border: 1px solid ",
        ";\n  box-shadow: unset;\n  transition: unset;\n  background: ",
        ";\n  cursor: pointer;\n\n  > p {\n    color: #858585;\n  }\n\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .ant-input-number-input-wrap {\n    height: 19px;\n    line-height: 19px;\n  }\n  \n  input {\n    padding: 0;\n    height: 19px;\n    line-height: 19px;\n    font-size: 14px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n  color: ",
        ";\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 8px;\n  gap: 8px;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 6px 0;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 4px;\n  left: 19px;\n  width: 4px;\n  height: 4px;\n  background: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-picker-time-panel {\n    width: auto;\n  }\n  .ant-picker-time-panel-column {\n    width: 56px;\n    padding-left: 6px;\n    padding-right: 4px;\n    overflow-y: scroll;\n\n    .ant-picker-time-panel-cell-inner {\n      width: 43px;\n      text-align: center;\n      padding-left: 0!important;\n      font-size: 13px;\n      font-family: 'ProximaNovaRg';\n    }\n\n    .ant-picker-time-panel-cell-selected > .ant-picker-time-panel-cell-inner {\n      border-radius: 4px;\n    }\n\n    .ant-picker-time-panel-cell-disabled {\n      display: none;\n    }\n  }\n\n  .ant-picker-ranges {\n    padding: 8px 6px;\n  }\n\n  .ant-picker-now-btn {\n    font-size: 12px !important;\n    font-family: 'ProximaNovaBd';\n    padding-left: 12px;\n    padding-right: 12px;\n    height: 28px;\n  }\n  \n  .ant-picker-ok {\n    float: none;\n    margin-left: 4px;\n    height: 28px;\n\n    .ant-btn {\n      width: 42px;\n      height: 28px;\n      span {\n        font-family: 'ProximaNovaBd';\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n\n  .ant-picker {\n    width: 142px;\n    height: 42px;\n    border-radius: 4px;\n    border: 1px solid #EDEDED;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var FormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a343fbbc-0"
})(AdvancedFilter_styled_templateObject());
var ButtonChip = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a343fbbc-1"
})(styled_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive ? color/* default.primary */.Z.primary : color/* default.downgray */.Z.downgray;
}, color/* default.light */.Z.light, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject1(), color/* default.primary */.Z.primary);
});
var NumberInput = (0,styled_components_browser_esm/* default */.ZP)(InputNumber/* default */.Z).attrs({
    controls: false
}).withConfig({
    componentId: "sc-a343fbbc-2"
})(styled_templateObject3(), color/* default.downgray */.Z.downgray);
var TextErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a343fbbc-3"
})(styled_templateObject4(), color/* default.sunsetOrange */.Z.sunsetOrange);
var FormFooterWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a343fbbc-4"
})(_templateObject5(), color/* default.downgray */.Z.downgray);
var styled_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a343fbbc-5"
})(_templateObject7(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), color/* default.light */.Z.light, color/* default.hummingBird */.Z.hummingBird, color/* default.light */.Z.light);
});
var Dot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a343fbbc-6"
})(_templateObject8(), color/* default.primary */.Z.primary);
var TimePickerPopoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a343fbbc-7"
})(_templateObject9());
var TimePickerInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    mb: "6px"
}).withConfig({
    componentId: "sc-a343fbbc-8"
})(_templateObject10());

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/utils.ts
var allowedNavigationKeys = [
    "ArrowLeft",
    "ArrowRight",
    "Backspace",
    "Delete"
];
var validateNumbersOnly = function(e) {
    if (/[^0-9]/.test(e.key) && allowedNavigationKeys.indexOf(e.key) === -1) {
        e.preventDefault();
    }
};
var formatterThousand = function(value) {
    return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var parserThousand = function(value) {
    return value.replace(/\$\s?|(,*)/g, "");
};
var onPasteNumbersOnly = function(e) {
    var clipboardData = e.clipboardData || window.Clipboard;
    var pastedData = clipboardData.getData("Text").toUpperCase();
    if (/[^0-9\-+.]/.test(pastedData)) {
        e.stopPropagation();
        e.preventDefault();
    }
};
var validateDecimalNumber = function(e) {
    var isNonNumericChar = /[^0-9\-+.]/.test(e.key);
    var isInvalidNavigationKey = allowedNavigationKeys.indexOf(e.key) === -1;
    if (isNonNumericChar && isInvalidNavigationKey) {
        e.preventDefault();
        return;
    }
    var dotCount = (e.target.value.match(/\./g) || []).length;
    if (dotCount === 1 && isInvalidNavigationKey) {
        var ref;
        if (e.key === "." || ((ref = e.target.value.split(".")[1]) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            e.preventDefault();
        }
    }
};

// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/utils.ts



var actionTypeMap = {
    0: "ACTION_TYPE_ALL",
    1: "ACTION_TYPE_BUY",
    2: "ACTION_TYPE_SELL"
};
var isNumber = function(value) {
    if (value === null || typeof value === "undefined") return false;
    var newN = Number(value);
    return !Number.isNaN(newN);
};
var mapCustomFilter = function(filter, isOpenMarket) {
    var mappedFilter = {};
    if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom && !isOpenMarket && filter.selected.length === 1) {
        mappedFilter.symbols = filter === null || filter === void 0 ? void 0 : filter.selected[0].split("#")[0];
    }
    if (mappedFilter.symbols && actionTypeMap[filter === null || filter === void 0 ? void 0 : filter.actionType]) {
        mappedFilter.action_type = actionTypeMap[filter === null || filter === void 0 ? void 0 : filter.actionType];
    }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.minPrice)) {
        mappedFilter.price_range_from = filter.minPrice;
    }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPrice)) {
        mappedFilter.price_range_to = filter.maxPrice;
    }
    // Uncomment if watchlist_id has been implemented on BE
    // if (isNumber(filter?.minPercentage)) {
    //   mappedFilter.price_change_from = filter.minPercentage;
    // }
    // Uncomment if watchlist_id has been implemented on BE
    // if (isNumber(filter?.maxPercentage)) {
    //   mappedFilter.price_change_to = filter.maxPercentage;
    // }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.minLot)) {
        mappedFilter.minimum_lot = filter.minLot;
    }
    if (mappedFilter.symbols && filter.timeRangeStart) {
        mappedFilter["time_range.start"] = filter.timeRangeStart;
    }
    if (mappedFilter.symbols && filter.timeRangeEnd) {
        mappedFilter["time_range.end"] = filter.timeRangeEnd;
    }
    // Uncomment if watchlist_id has been implemented on BE
    // if (filter?.type === StockFilterTypeEnum.Watchlist && !isOpenMarket) {
    //   mappedFilter.watchlist_id = parseInt(`${filter?.watchlistId}`, 10);
    // }
    return mappedFilter;
};
var parseNumberFilter = function(type, value) {
    if (isNumber(value)) {
        return value;
    }
    if (type === "min") {
        return Number.MIN_SAFE_INTEGER;
    }
    return Number.MAX_SAFE_INTEGER;
};
var filterRunningTrade = function(items, filter, stockFilter) {
    return items.filter(function(item) {
        var ref;
        var isCustomOrWatchlist = (stockFilter === null || stockFilter === void 0 ? void 0 : stockFilter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom || (stockFilter === null || stockFilter === void 0 ? void 0 : stockFilter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist;
        if (isCustomOrWatchlist && (stockFilter === null || stockFilter === void 0 ? void 0 : (ref = stockFilter.selected) === null || ref === void 0 ? void 0 : ref.length) > 0 && !stockFilter.selected.map(function(symbol) {
            return symbol.split("#")[0];
        }).includes(item.stock) // check if stock is not on selected symbol
        ) {
            return false;
        }
        var ref1 = (0,_sliced_to_array/* default */.Z)(Array(6).fill(false), 6), isMatchingAction = ref1[0], isWithinMinPrice = ref1[1], isWithinMaxPrice = ref1[2], meetsMinPercentage = ref1[3], meetsMaxPercentage = ref1[4], meetsMinLot = ref1[5];
        if (!filter) {
            isMatchingAction = true;
        } else if ((filter === null || filter === void 0 ? void 0 : filter.actionType) === types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL) {
            isMatchingAction = true;
        } else if (item.action === (filter === null || filter === void 0 ? void 0 : filter.actionType)) {
            isMatchingAction = true;
        }
        if (item.price >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minPrice)) {
            isWithinMinPrice = true;
        }
        if (item.price <= parseNumberFilter("max", filter === null || filter === void 0 ? void 0 : filter.maxPrice)) {
            isWithinMaxPrice = true;
        }
        if (Math.floor(item.change.percentage * 100) / 100 >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minPercentage)) {
            meetsMinPercentage = true;
        }
        if (Math.floor(item.change.percentage * 100) / 100 <= parseNumberFilter("max", filter === null || filter === void 0 ? void 0 : filter.maxPercentage)) {
            meetsMaxPercentage = true;
        }
        if (item.volume / constant/* lotSize */.CQ >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minLot)) {
            meetsMinLot = true;
        }
        return isMatchingAction && isWithinMinPrice && isWithinMaxPrice && meetsMinPercentage && meetsMaxPercentage && meetsMinLot;
    });
};

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/index.tsx
















var AdvancedFilter = function(param) {
    var isMarketOpen = param.isMarketOpen, _timeFormat = param.timeFormat, timeFormat = _timeFormat === void 0 ? "HH:mm" : _timeFormat;
    var popoverRef = (0,react.useRef)(null);
    var popoverButtonRef = (0,react.useRef)(null);
    var filter = (0,store/* useFilterStore */.r)(function(s) {
        return s.filter;
    });
    var onApplyFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyFilter;
    });
    var onResetFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onResetFilter;
    });
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL), actionType = ref1[0], setActionType = ref1[1];
    var ref2 = (0,react.useState)(null), minPrice = ref2[0], setMinPrice = ref2[1];
    var ref3 = (0,react.useState)(null), maxPrice = ref3[0], setMaxPrice = ref3[1];
    var ref4 = (0,react.useState)(null), minPercentage = ref4[0], setMinPercentage = ref4[1];
    var ref5 = (0,react.useState)(null), maxPercentage = ref5[0], setMaxPercentage = ref5[1];
    var ref6 = (0,react.useState)(null), minLot = ref6[0], setMinLot = ref6[1];
    var ref7 = (0,react.useState)(null), timeRangeStart = ref7[0], setTimeRangeStart = ref7[1];
    var ref8 = (0,react.useState)(null), timeRangeEnd = ref8[0], setTimeRangeEnd = ref8[1];
    var handleClickOutside = function(event) {
        var ref;
        event.preventDefault();
        if ((ref = popoverButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) return;
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        if (visible) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        visible
    ]);
    var handleResetForm = function() {
        setActionType(types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL);
        setMinPrice(null);
        setMaxPrice(null);
        setMinPercentage(null);
        setMaxPercentage(null);
        setMinLot(null);
        setTimeRangeStart(null);
        setTimeRangeEnd(null);
        clearData("widget");
        onResetFilter();
    };
    var handleApplyFilter = function() {
        setVisible(false);
        clearData("widget");
        onApplyFilter({
            minPrice: minPrice,
            maxPrice: maxPrice,
            minPercentage: minPercentage,
            maxPercentage: maxPercentage,
            minLot: minLot,
            actionType: actionType,
            timeRangeStart: timeRangeStart ? timeRangeStart.format(timeFormat).toString() : null,
            timeRangeEnd: timeRangeEnd ? timeRangeEnd.format(timeFormat).toString() : null
        });
    };
    var handleClickButton = function() {
        var isVisible = !visible;
        setVisible(isVisible);
        if (isVisible) {
            setActionType((filter === null || filter === void 0 ? void 0 : filter.actionType) || types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL);
            setMinPrice(isNumber(filter === null || filter === void 0 ? void 0 : filter.minPrice) ? filter === null || filter === void 0 ? void 0 : filter.minPrice : null);
            setMaxPrice(isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPrice) ? filter === null || filter === void 0 ? void 0 : filter.maxPrice : null);
            setMinPercentage(isNumber(filter === null || filter === void 0 ? void 0 : filter.minPercentage) ? filter === null || filter === void 0 ? void 0 : filter.minPercentage : null);
            setMaxPercentage(isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPercentage) ? filter === null || filter === void 0 ? void 0 : filter.maxPercentage : null);
            setMinLot(isNumber(filter === null || filter === void 0 ? void 0 : filter.minLot) ? filter === null || filter === void 0 ? void 0 : filter.minLot : null);
        }
    };
    var onPasteNumberValidate = function(e) {
        var clipboardData = e.clipboardData || window.Clipboard;
        var pastedData = clipboardData.getData("Text").toUpperCase();
        if (pastedData.indexOf("E") > -1) {
            e.stopPropagation();
            e.preventDefault();
        }
    };
    var priceRangeValidation = (0,react.useMemo)(function() {
        if (!isNumber(maxPrice) || !isNumber(minPrice)) return null;
        if (maxPrice < minPrice) {
            return {
                message: "Maximum price must be greater than the minimum price",
                status: "error"
            };
        }
        return null;
    }, [
        minPrice,
        maxPrice
    ]);
    var percentageValidation = (0,react.useMemo)(function() {
        if (!isNumber(maxPercentage) || !isNumber(minPercentage)) return null;
        if (maxPercentage < minPercentage) {
            return {
                message: "Maximum price change must be greater than the minimum price change",
                status: "error"
            };
        }
        return null;
    }, [
        minPercentage,
        maxPercentage
    ]);
    var timeRangeValidation = (0,react.useMemo)(function() {
        if (isMarketOpen) return null;
        if (timeRangeStart && timeRangeEnd) {
            var isNotValid = moment_default()(timeRangeEnd, "HH:mm").isBefore(moment_default()(timeRangeStart, "HH:mm"));
            if (isNotValid) {
                return {
                    message: "The end time must be later than the start time.",
                    status: "error"
                };
            }
        }
        return null;
    }, [
        isMarketOpen,
        timeRangeStart,
        timeRangeEnd
    ]);
    var isButtonApplyDisabled = (0,react.useMemo)(function() {
        if (priceRangeValidation || percentageValidation || timeRangeValidation) {
            return true;
        }
        return false;
    }, [
        priceRangeValidation,
        percentageValidation,
        timeRangeValidation
    ]);
    var isFilterApplied = (0,react.useMemo)(function() {
        var arrayFilterType = [
            _typeof(filter === null || filter === void 0 ? void 0 : filter.minPrice),
            _typeof(filter === null || filter === void 0 ? void 0 : filter.maxPrice),
            _typeof(filter === null || filter === void 0 ? void 0 : filter.minPercentage),
            _typeof(filter === null || filter === void 0 ? void 0 : filter.maxPercentage),
            _typeof(filter === null || filter === void 0 ? void 0 : filter.minLot), 
        ];
        if (!filter) return false;
        if (arrayFilterType.includes("number") || (filter === null || filter === void 0 ? void 0 : filter.actionType) !== types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL) {
            return true;
        }
        if ((filter === null || filter === void 0 ? void 0 : filter.timeRangeStart) || filter.timeRangeEnd) {
            return true;
        }
        return false;
    }, [
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonDropdownTrigger, {
                ref: popoverButtonRef,
                onClick: handleClickButton,
                isOpened: visible,
                style: {
                    padding: "6px 10px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/rt-filter.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        children: "Filter"
                    }),
                    isFilterApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {})
                ]
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                ref: popoverRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Action Type"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        style: {
                                            gap: 12
                                        },
                                        children: actionTypeMenus.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChip, {
                                                isActive: actionType === item.key,
                                                onClick: function() {
                                                    return setActionType(item.key);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    size: "12px",
                                                    children: item.label
                                                })
                                            }, item.key);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Price Range (Rp)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            gap: 16
                                        },
                                        mb: "6px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMinPrice(Number(value));
                                                },
                                                value: minPrice,
                                                placeholder: "From",
                                                // @ts-expect-error
                                                status: priceRangeValidation === null || priceRangeValidation === void 0 ? void 0 : priceRangeValidation.status,
                                                min: 0,
                                                max: 999999,
                                                maxlength: 7,
                                                onKeyDown: validateNumbersOnly,
                                                onPaste: onPasteNumbersOnly,
                                                formatter: formatterThousand,
                                                parser: parserThousand
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMaxPrice(Number(value));
                                                },
                                                value: maxPrice,
                                                placeholder: "To",
                                                min: 0,
                                                max: 999999,
                                                // @ts-expect-error
                                                maxlength: 7,
                                                onKeyDown: validateNumbersOnly,
                                                onPaste: onPasteNumbersOnly,
                                                formatter: formatterThousand,
                                                parser: parserThousand
                                            })
                                        ]
                                    }),
                                    priceRangeValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: priceRangeValidation.message
                                    })
                                ]
                            }),
                            isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Price Change (%)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            gap: 16
                                        },
                                        mb: "6px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMinPercentage(Number(value));
                                                },
                                                value: minPercentage,
                                                placeholder: "From",
                                                // @ts-expect-error
                                                status: percentageValidation === null || percentageValidation === void 0 ? void 0 : percentageValidation.status,
                                                min: -35,
                                                max: 35,
                                                maxlength: 6,
                                                onKeyDown: validateDecimalNumber,
                                                onPaste: onPasteNumbersOnly
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMaxPercentage(Number(value));
                                                },
                                                value: maxPercentage,
                                                placeholder: "To",
                                                min: -35,
                                                max: 35,
                                                // @ts-expect-error
                                                maxlength: 6,
                                                onKeyDown: validateDecimalNumber,
                                                onPaste: onPasteNumbersOnly
                                            })
                                        ]
                                    }),
                                    percentageValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: percentageValidation.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Minimum Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        mb: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                            onChange: function(value) {
                                                return setMinLot(Number(value));
                                            },
                                            value: minLot,
                                            placeholder: "e.g 1000",
                                            onKeyDown: validateNumbersOnly,
                                            onPaste: onPasteNumberValidate,
                                            formatter: formatterThousand,
                                            parser: parserThousand,
                                            max: 50000
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        style: {
                                            gap: 8
                                        },
                                        children: predefinedLot.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChip, {
                                                isActive: item.value === minLot,
                                                onClick: function() {
                                                    return setMinLot(item.value);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    size: "12px",
                                                    children: item.label
                                                })
                                            }, item.value);
                                        })
                                    })
                                ]
                            }),
                            !isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Time Range"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePickerPopoverContainer, {
                                        id: "rt-advanced-time-picker"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimePickerInputContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker, {
                                                defaultValue: timeRangeStart,
                                                format: timeFormat,
                                                getPopupContainer: function() {
                                                    return document.getElementById("rt-advanced-time-picker");
                                                },
                                                suffixIcon: null,
                                                placeholder: "from",
                                                onChange: function(value) {
                                                    return setTimeRangeStart(value);
                                                },
                                                value: timeRangeStart
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker, {
                                                defaultValue: timeRangeEnd,
                                                format: timeFormat,
                                                getPopupContainer: function() {
                                                    return document.getElementById("rt-advanced-time-picker");
                                                },
                                                suffixIcon: null,
                                                placeholder: "to",
                                                onChange: function(value) {
                                                    return setTimeRangeEnd(value);
                                                },
                                                value: timeRangeEnd
                                            })
                                        ]
                                    }),
                                    timeRangeValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: timeRangeValidation.message
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormFooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                                onClick: handleResetForm,
                                style: {
                                    color: "#858585"
                                },
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                                onClick: handleApplyFilter,
                                type: "primary",
                                disabled: isButtonApplyDisabled,
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ActionControl_AdvancedFilter = (AdvancedFilter);

// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/AllStock/styled.ts

function AllStock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 8px 10px 8px;\n"
    ]);
    AllStock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllStock_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: 1px solid ",
        ";\n  cursor: pointer;\n  width: 100%;\n  border-radius: 4px;\n\n  .ant-checkbox {\n    top: 0;\n  }\n"
    ]);
    AllStock_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f987a381-0"
})(AllStock_styled_templateObject());
var AllStockButton = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-f987a381-1"
})(AllStock_styled_templateObject1(), color/* default.downgray */.Z.downgray);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/AllStock/index.tsx





var AllStock = function(param) {
    var isChecked = param.isChecked, setFilter = param.setFilter;
    var onCheck = function() {
        setFilter({
            type: types/* StockFilterTypeEnum.AllStock */.d.AllStock
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        onClick: onCheck,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AllStockButton, {
            px: "16px",
            py: "8.5px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    weight: "700",
                    children: "All Stocks"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Checkbox, {
                    checked: isChecked
                })
            ]
        })
    });
};
/* harmony default export */ var StocksFilter_AllStock = (AllStock);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/styled.ts

function MyWatchlist_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 8px 10px 8px;\n"
    ]);
    MyWatchlist_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  padding: 12px 16px 6px 16px;\n\n  .item:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    MyWatchlist_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  border-radius: 4px;\n  background-color: #F6F6F6;\n"
    ]);
    MyWatchlist_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n\n  .checkbox {\n    width: 15.417px;\n    height: 15.417px;\n    border: 1px solid ",
        ";\n    border-radius: 50%;\n  }\n"
    ]);
    MyWatchlist_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MyWatchlistWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1cf7c5f-0"
})(MyWatchlist_styled_templateObject());
var MyWatchlistResult = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1cf7c5f-1"
})(MyWatchlist_styled_templateObject1(), color/* default.downgray */.Z.downgray, color/* default.downgray */.Z.downgray);
var SkeletonItemText = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a1cf7c5f-2"
})(MyWatchlist_styled_templateObject2());
var SkeletonItemCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1cf7c5f-3"
})(MyWatchlist_styled_templateObject3(), color/* default.downgray */.Z.downgray);

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/store.ts






var watchlistListStore = (0,esm/* default */.ZP)(function(set) {
    return {
        isLoading: false,
        data: [],
        hasNext: true,
        fetch: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(page) {
                var res, _data, data, message, error_type, error;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                if (page === 1) {
                                    state.data = [];
                                    state.hasNext = true;
                                }
                                state.isLoading = true;
                            }));
                            _ctx.next = 3;
                            return watchlist/* default.getAllWatchlist */.Z.getAllWatchlist(null, true, page, 10);
                        case 3:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while search company data");
                        case 6:
                            _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                            if (!(error || error_type)) {
                                _ctx.next = 10;
                                break;
                            }
                            set({
                                isLoading: false
                            });
                            throw new Error(message);
                        case 10:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                if (page === 1) {
                                    state.data = data;
                                } else if (page > 1) {
                                    var _data;
                                    (_data = state.data).push.apply(_data, (0,_to_consumable_array/* default */.Z)(data));
                                }
                                if (data.length < 10) {
                                    state.hasNext = false;
                                }
                                state.isLoading = false;
                            }));
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/index.tsx
/* eslint-disable react/no-array-index-key */ 












var WatchlistItem = function(props) {
    var name = props.name, totalItems = props.total_items, onClick = props.onClick, isChecked = props.isChecked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        // @ts-expect-error
        py: "10px",
        justify: "space-between",
        align: "center",
        className: "item",
        onClick: function() {
            return onClick(props);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "13px",
                ellipsis: true,
                width: "140px",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                style: {
                    gap: 32
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        size: "13px",
                        color: "#858585",
                        children: [
                            totalItems,
                            " Stocks"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Checkbox, {
                        checked: isChecked
                    })
                ]
            })
        ]
    });
};
var MyWatchlist = function(param) {
    var filter = param.filter, setFilter = param.setFilter;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var isLoading = watchlistListStore(function(s) {
        return s.isLoading;
    });
    var data = watchlistListStore(function(s) {
        return s.data;
    });
    var hasNext = watchlistListStore(function(s) {
        return s.hasNext;
    });
    var fetchWatchlist = watchlistListStore(function(s) {
        return s.fetch;
    });
    (0,react.useEffect)(function() {
        fetchWatchlist(page);
    }, [
        page
    ]);
    var handleLoadMore = function(isVisible) {
        if (isVisible && !isLoading && hasNext) {
            setPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var handleSelectWatchlist = function(watchlist) {
        setFilter({
            type: types/* StockFilterTypeEnum.Watchlist */.d.Watchlist,
            watchlistId: watchlist.watchlist_id,
            watchlistName: watchlist.name,
            watchlistItemCounts: watchlist.total_items
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyWatchlistWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlistResult, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    weight: "700",
                    mb: "8px",
                    children: "From My Watchlist"
                }),
                data.map(function(item) {
                    /*#__PURE__*/ return (0,react.createElement)(WatchlistItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        key: item.watchlist_id,
                        onClick: handleSelectWatchlist,
                        isChecked: (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist && (filter === null || filter === void 0 ? void 0 : filter.watchlistId) === item.watchlist_id
                    }));
                }),
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(___, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            align: "center",
                            justify: "space-between",
                            // @ts-expect-error
                            py: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemText, {
                                    width: "70px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    style: {
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemText, {
                                            width: "70px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemCheckbox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "checkbox"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                }),
                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                    onChange: handleLoadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "\xa0"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var StocksFilter_MyWatchlist = (MyWatchlist);

// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/hooks/useClickOutside.ts
var useClickOutside = __webpack_require__(1014);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/styled.ts

function SearchStock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border: none;\n  padding: 0 16px 0 0;\n\n  .ant-input-affix-wrapper {\n    border-radius: 4px;\n  }\n\n  .ant-input {\n    height: 20px;\n    line-height: 20px;\n    font-size: 13px;\n  }\n\n  .ant-input-prefix {\n    margin-right: 8px;\n    height: 20px;\n    line-height: 20px;\n  }\n"
    ]);
    SearchStock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 14px 8px;\n"
    ]);
    SearchStock_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 8px 0px 8px 16px;\n"
    ]);
    SearchStock_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  border-bottom: 1px solid ",
        ";\n  width: calc(100% - 16px);\n"
    ]);
    SearchStock_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: 20px;\n  padding: 4px 3px 4px 5px;\n  border: 1px solid ",
        ";\n  flex: 0 0 auto;\n  order: 0;\n  margin-bottom: 10px;\n  margin-right: 4px;\n  align-items: center;\n\n  .remove-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    margin-left: 6px;\n    cursor: pointer;\n\n    img {\n      width: 6.6px;\n      height: 6.6px;\n    }\n  }\n"
    ]);
    SearchStock_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 50px;\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 318px;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 246px;\n  height: 20px;\n  border-radius: 4px;\n  background-color: #F6F6F6;\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n\n  .checkbox {\n    width: 15.417px;\n    height: 15.417px;\n    border-radius: 50%;\n    background-color: #F6F6F6;\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 50%;\n  color: ",
        ";\n  display: flex;\n  min-height: 20px;\n  min-width: 20px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .add {\n      cursor: not-allowed;\n      pointer-events: all !important;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .selected {\n    width: 15px;\n    height: 15px;\n  }\n\n  .add {\n    width: 15.417px;\n    height: 15.417px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 8px;\n  gap: 8px;\n  border-top: 1px solid ",
        ";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 6px 0;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 12px;\n  cursor: ",
        ";\n  :hover {\n    background: #F7F7F7;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





var SearchInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-4daccd35-0"
})(SearchStock_styled_templateObject());
var SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-1"
})(SearchStock_styled_templateObject1());
var SearchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-2"
})(SearchStock_styled_templateObject2(), color/* default.downgray */.Z.downgray);
var SearchInputDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-3"
})(SearchStock_styled_templateObject3(), color/* default.downgray */.Z.downgray);
var StockChipWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-4"
})(SearchStock_styled_templateObject4(), color/* default.downgray */.Z.downgray);
var CompanySearchResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-5"
})(styled_templateObject5());
var SkeletonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-6"
})(styled_templateObject6());
var SkeletonItemWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-7"
})(styled_templateObject7());
var styled_SkeletonItemText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-8"
})(styled_templateObject8());
var styled_SkeletonItemCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-9"
})(styled_templateObject9());
var ImagePlaceholder = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4daccd35-10"
})(styled_templateObject10(), color/* default.light */.Z.light);
var SearchStock_styled_Checkbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4daccd35-11"
})(_templateObject12(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject11());
});
var styled_FormFooterWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4daccd35-12"
})(_templateObject13(), color/* default.downgray */.Z.downgray, color/* default.light */.Z.light);
var SearchStock_styled_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-4daccd35-13"
})(_templateObject15(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), color/* default.light */.Z.light, color/* default.hummingBird */.Z.hummingBird, color/* default.light */.Z.light);
});
var SearchItemContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    px: "20px",
    py: "10px",
    align: "center"
}).withConfig({
    componentId: "sc-4daccd35-14"
})(_templateObject16(), // @ts-expect-error
function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "not-allowed" : "pointer";
});

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/styled.ts

function StocksFilter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  padding: 10px 8px;\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    StocksFilter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    StocksFilter_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  font-weight: 700;\n  padding: 6px;\n  font-size: 12px;\n  line-height: 16px;\n\n  ",
        "\n"
    ]);
    StocksFilter_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 0.6;\n  "
    ]);
    StocksFilter_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 8px;\n  flex-flow: wrap;\n  justify-content: left;\n  align-items: flex-start;\n  overflow: auto;\n\n  ",
        "\n"
    ]);
    StocksFilter_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 451px;\n  overflow: auto;\n"
    ]);
    StocksFilter_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    StocksFilter_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var FooterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1770a7b5-0"
})(StocksFilter_styled_templateObject(), color/* default.downgray */.Z.downgray, color/* default.light */.Z.light);
var ButtonApply = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    block: true,
    type: "primary"
}).withConfig({
    componentId: "sc-1770a7b5-1"
})(StocksFilter_styled_templateObject2(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm/* css */.iv)(StocksFilter_styled_templateObject1(), color/* default.light */.Z.light, color/* default.hummingBird */.Z.hummingBird, color/* default.light */.Z.light);
});
var SelectedSymbolWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1770a7b5-2"
})(StocksFilter_styled_templateObject4(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(StocksFilter_styled_templateObject3());
});
var DropdownContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1770a7b5-3"
})(StocksFilter_styled_templateObject5());
var StockCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1770a7b5-4"
})(StocksFilter_styled_templateObject6(), color/* default.hummingBird */.Z.hummingBird);

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/components/CompanyIcon.tsx

function CompanyIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 50%;\n  color: ",
        ";\n  display: flex;\n  min-height: 20px;\n  min-width: 20px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    CompanyIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CompanyIcon_ImagePlaceholder = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-cdd05b0e-0"
})(CompanyIcon_templateObject(), color/* default.light */.Z.light);
var CompanyIcon = function(param) {
    var symbol = param.symbol;
    var ref = (0,react.useState)(true), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    if (isIconAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "".concat(app/* assetsStatic */.mM, "/logos/companies/").concat(symbol, ".png"),
            alt: symbol,
            width: 20,
            height: 20,
            onError: function() {
                return setIsIconAvailable(false);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIcon_ImagePlaceholder, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            children: !!symbol && symbol.toUpperCase().slice(0, 1)
        })
    });
};
/* harmony default export */ var components_CompanyIcon = (CompanyIcon);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/StockChip.tsx






var StockChip = function(param) {
    var symbol = param.symbol, onRemove = param.onRemove;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockChipWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                        symbol: symbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        // @ts-expect-error
                        ml: "4px",
                        size: "13px",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "remove-icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/close.svg",
                    onClick: function(e) {
                        e.stopPropagation();
                        onRemove(symbol);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var SearchStock_StockChip = (StockChip);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/SearchItem.tsx
/* eslint-disable react/destructuring-assignment */ 






var TooltipContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "12px",
            height: "18px",
            children: "Maximum 25 stocks"
        })
    });
};
var AddCheckbox = function(param) {
    var isSelected = param.isSelected, isDisabled = param.isDisabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: isDisabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {}) : false,
        overlayInnerStyle: {
            background: color/* default.light */.Z.light,
            padding: "8px 16px",
            border: "1px solid ".concat(color/* default.downgray */.Z.downgray)
        },
        overlayClassName: "tooltip-overlay-transparent",
        placement: "bottom",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_styled_Checkbox, {
            isDisabled: isDisabled,
            children: isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/rt-company-checkmark.svg",
                class: "selected"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/rt-company-add.svg",
                class: "add"
            })
        })
    });
};
var SearchItem = function(props) {
    var symbolName = props.name, symbol = props.symbol_2, desc = props.desc, onSelect = props.onSelect, onRemove = props.onRemove, isSelected = props.isSelected, isDisabled = props.isDisabled, hasCheckbox = props.hasCheckbox;
    var handleClickCheckbox = function() {
        if (isSelected) {
            onRemove("".concat(symbol, "#").concat(symbolName));
        } else {
            onSelect("".concat(symbol, "#").concat(symbolName));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchItemContainer, {
        onClick: isDisabled && !isSelected ? null : handleClickCheckbox,
        // @ts-expect-error
        isDisabled: isDisabled && !isSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                weight: "700",
                width: "52px",
                ellipsis: true,
                children: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                width: hasCheckbox ? "150px" : "180px",
                ellipsis: true,
                children: desc
            }),
            hasCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCheckbox, {
                isSelected: isSelected,
                isDisabled: isDisabled && !isSelected
            })
        ]
    });
};
/* harmony default export */ var SearchStock_SearchItem = (SearchItem);

// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/store.ts







var initialState = {
    isLoading: false,
    data: [],
    hasMoreCompany: false
};
var searchCompanyStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        fetch: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(query, page) {
                var res, _data, data, message, error_type, error;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(query.length > 1)) {
                                _ctx.next = 13;
                                break;
                            }
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return search/* default.getSearchCompany */.Z.getSearchCompany(query, page);
                        case 4:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while search company data");
                        case 7:
                            _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                            if (!(error || error_type)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(message);
                        case 10:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state.data = data.company;
                                state.hasMoreCompany = data.pagination.has_more_companies;
                                state.isLoading = false;
                            }));
                            _ctx.next = 14;
                            break;
                        case 13:
                            {
                                set((0,_object_spread/* default */.Z)({}, initialState));
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(query, page) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
var selectedSymbolStore = (0,esm/* default */.ZP)(function(set) {
    return {
        symbols: [],
        updateSymbols: function(symbols) {
            set({
                symbols: symbols
            });
        }
    };
});


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/index.tsx
/* eslint-disable react/no-array-index-key */ 


















var SearchStock = function(param) {
    var isAllowMultipleSelect = param.isAllowMultipleSelect, filter = param.filter, setFilter = param.setFilter, showResult = param.showResult, onShowSearchResult = param.onShowSearchResult, onApplyStockFilter = param.onApplyStockFilter;
    var searchCompany = searchCompanyStore(function(s) {
        return s.fetch;
    });
    var searchResult = searchCompanyStore(function(s) {
        return s.data;
    });
    var isLoading = searchCompanyStore(function(s) {
        return s.isLoading;
    });
    var selectedSymbol = selectedSymbolStore(function(store) {
        return store.symbols;
    });
    var updateSymbols = selectedSymbolStore(function(s) {
        return s.updateSymbols;
    });
    var isDisabled = (filter === null || filter === void 0 ? void 0 : filter.type) !== types/* StockFilterTypeEnum.Custom */.d.Custom;
    var ref = (0,react.useState)([]), tempSelectedSymbol = ref[0], setTempSelectedSymbol = ref[1];
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,useClickOutside/* default */.Z)(function() {
        if (showResult && isAllowMultipleSelect) {
            var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat((0,_to_consumable_array/* default */.Z)(tempSelectedSymbol));
            updateSymbols(appliedSymbol);
            setTempSelectedSymbol([]);
            setKeyword("");
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: appliedSymbol
            });
        }
    }), searchStockRef = ref2.ref;
    var keywordDebounce = (0,useDebounce/* default */.Z)(keyword, 500);
    (0,react.useEffect)(function() {
        setKeyword("");
    }, []);
    (0,react.useEffect)(function() {
        searchCompany(keywordDebounce, 1);
    }, [
        keywordDebounce
    ]);
    var onSelectCompany = function(symbol) {
        if (isAllowMultipleSelect) {
            setTempSelectedSymbol(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    symbol
                ]);
            });
        } else {
            setTempSelectedSymbol(function() {
                return [
                    symbol
                ];
            });
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: [
                    symbol
                ]
            });
        }
    };
    var onRemoveCompany = function(symbol) {
        if (tempSelectedSymbol.includes(symbol)) {
            var updatedSymbols = tempSelectedSymbol.filter(function(item) {
                return item !== symbol;
            });
            setTempSelectedSymbol(updatedSymbols);
        }
        if (selectedSymbol.includes(symbol)) {
            var updatedSymbols1 = selectedSymbol.filter(function(item) {
                return item !== symbol;
            });
            updateSymbols(updatedSymbols1);
        }
    };
    var handlePressEnter = function(e) {
        var findSymbol = searchResult.find(function(item) {
            var ref, ref1;
            return ((ref = item.symbol_2) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === ((ref1 = e.target.value) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
        });
        if (findSymbol && isAllowMultipleSelect) {
            var symbolCombined = "".concat(findSymbol.symbol_2, "#").concat(findSymbol.name);
            var isAlreadyAdded = selectedSymbol.includes(symbolCombined);
            if (!isAlreadyAdded) {
                var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat([
                    symbolCombined
                ]);
                onApplyStockFilter({
                    type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                    selected: appliedSymbol
                });
                updateSymbols(appliedSymbol);
                setTempSelectedSymbol([]);
            }
        } else if (findSymbol && !isAllowMultipleSelect) {
            var symbolCombined1 = "".concat(findSymbol.symbol_2, "#").concat(findSymbol.name);
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: [
                    symbolCombined1
                ]
            });
            updateSymbols([
                symbolCombined1
            ]);
            setTempSelectedSymbol([]);
        }
    };
    var onClickAdd = function() {
        var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat((0,_to_consumable_array/* default */.Z)(tempSelectedSymbol));
        updateSymbols(appliedSymbol);
        setTempSelectedSymbol([]);
        setKeyword("");
        onShowSearchResult(false);
        onApplyStockFilter({
            type: types/* StockFilterTypeEnum.Custom */.d.Custom,
            selected: appliedSymbol
        });
    };
    var onClickCancel = function() {
        onShowSearchResult(false);
        setTempSelectedSymbol([]);
    };
    var isEmpty = (0,react.useMemo)(function() {
        if (searchResult.length === 0 && keyword.length > 1) {
            return true;
        }
        return false;
    }, [
        isLoading,
        searchResult,
        keyword
    ]);
    (0,react.useEffect)(function() {
        setFilter({
            type: types/* StockFilterTypeEnum.Custom */.d.Custom,
            selected: selectedSymbol
        });
    }, [
        selectedSymbol
    ]);
    (0,react.useEffect)(function() {
        // reset selected symbol if user remove symbol but not apply the filter
        if (filter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && filter.selected !== selectedSymbol) {
            updateSymbols(filter.selected);
        }
    }, [
        filter
    ]);
    var showSelectedSymbolChip = isAllowMultipleSelect && !showResult && selectedSymbol.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: searchStockRef,
        style: {
            height: showResult ? "100%" : "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchContainer, {
                        onClick: function() {
                            setFilter({
                                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                                selected: selectedSymbol
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/search-rounded.svg",
                                        alt: "icon",
                                        width: "14px",
                                        height: "13px"
                                    }),
                                    placeholder: "Search Stocks",
                                    value: keyword,
                                    onChange: function(e) {
                                        onShowSearchResult(true);
                                        setKeyword(e.target.value);
                                    },
                                    onPressEnter: handlePressEnter,
                                    "data-cy": data_cy/* default.RUNNING_TRADE.SEARCH_INPUT */.Z.RUNNING_TRADE.SEARCH_INPUT
                                })
                            }),
                            showSelectedSymbolChip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedSymbolWrapper, {
                                        isDisabled: isDisabled,
                                        children: selectedSymbol.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_StockChip, {
                                                symbol: item.split("#")[0],
                                                onRemove: function() {
                                                    return onRemoveCompany(item);
                                                }
                                            }, item);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedSymbol.length >= 25 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: "#858585",
                        children: "*Maximum 25 Stocks"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: showResult ? "block" : "none"
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(___, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkeletonItemWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_SkeletonItemText, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_SkeletonItemCheckbox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "checkbox"
                                        })
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isLoading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isEmpty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    justify: "center",
                                    direction: "column",
                                    height: "410px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/illustration/empty-search-running-trade.svg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mt: "16px",
                                            size: "13px",
                                            color: "#858585",
                                            children: "No result found"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isEmpty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchResultWrapper, {
                                    children: searchResult.map(function(item) {
                                        return /*#__PURE__*/ (0,react.createElement)(SearchStock_SearchItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            key: item.id,
                                            onSelect: onSelectCompany,
                                            onRemove: onRemoveCompany,
                                            isSelected: selectedSymbol.includes("".concat(item.symbol_2, "#").concat(item.name)) || tempSelectedSymbol.includes("".concat(item.symbol_2, "#").concat(item.name)),
                                            isDisabled: selectedSymbol.length + tempSelectedSymbol.length >= 25,
                                            hasCheckbox: isAllowMultipleSelect
                                        }));
                                    })
                                })
                            })
                        ]
                    }),
                    isAllowMultipleSelect && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_FormFooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_styled_Button, {
                                onClick: onClickCancel,
                                style: {
                                    color: "#858585"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_styled_Button, {
                                type: "primary",
                                onClick: onClickAdd,
                                disabled: tempSelectedSymbol.length === 0,
                                children: "Add"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StocksFilter_SearchStock = (SearchStock);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/DropdownContent.tsx












var DropdownContent = function(param) {
    var isMarketOpen = param.isMarketOpen, onClosePopover = param.onClosePopover;
    var ref = (0,react.useState)(false), showResult = ref[0], setShowResult = ref[1];
    var defaultFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var onApplyFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyStockFilter;
    });
    var onResetActionFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onResetFilter;
    });
    var ref1 = (0,react.useState)(defaultFilter), filter = ref1[0], setFilter = ref1[1];
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var onClickApply = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var appliedFilter, res, _data, data, message, error_type, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        appliedFilter = filter;
                        if (!((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 4;
                        return watchlist/* default.getSymbolWatchlist */.Z.getSymbolWatchlist(filter === null || filter === void 0 ? void 0 : filter.watchlistId);
                    case 4:
                        res = _ctx.sent;
                        if (res.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error while search company data");
                    case 7:
                        _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                        if (!(error || error_type)) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(message);
                    case 10:
                        appliedFilter.selected = data === null || data === void 0 ? void 0 : data.symbols;
                        setFilter(appliedFilter);
                    case 12:
                        if (!isMarketOpen && (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock) {
                            onResetActionFilter();
                        }
                        onApplyFilter(appliedFilter);
                        clearData("widget");
                        onClosePopover();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickApply() {
            return _ref.apply(this, arguments);
        };
    }();
    var isButtonDisabled = (0,react.useMemo)(function() {
        if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom) {
            if (isMarketOpen) {
                return filter.selected.length === 0;
            }
            return true;
        }
        if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist) {
            return filter.watchlistItemCounts === 0;
        }
        return filter === null;
    }, [
        filter
    ]);
    (0,react.useEffect)(function() {
        // reset default active filter
        setFilter(defaultFilter);
    }, []);
    var onApplyStockFilter = function(value) {
        setFilter(value);
        onApplyFilter(value);
        clearData("widget");
        onClosePopover();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_SearchStock, {
                        filter: filter,
                        setFilter: setFilter,
                        showResult: showResult,
                        onShowSearchResult: function(show) {
                            return setShowResult(show);
                        },
                        onApplyStockFilter: onApplyStockFilter,
                        isAllowMultipleSelect: isMarketOpen
                    }),
                    !showResult && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_AllStock, {
                                isChecked: (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock,
                                setFilter: setFilter
                            }),
                            isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_MyWatchlist, {
                                filter: filter,
                                setFilter: setFilter
                            })
                        ]
                    })
                ]
            }),
            !showResult && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonApply, {
                    disabled: isButtonDisabled,
                    onClick: onClickApply,
                    children: "Apply"
                })
            })
        ]
    });
};
/* harmony default export */ var StocksFilter_DropdownContent = (DropdownContent);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/index.tsx












var StocksFilter = function(param) {
    var isMarketOpen = param.isMarketOpen;
    var ref, ref1, ref2;
    var popoverRef = (0,react.useRef)(null);
    var popoverButtonRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var selectedStockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var handleClickOutside = function(event) {
        var ref;
        if ((ref = popoverButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) return;
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        if (visible) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonDropdownTrigger, {
                onClick: function() {
                    return setVisible(!visible);
                },
                isOpened: visible,
                ref: popoverButtonRef,
                children: [
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref = selectedStockFilter.selected) === null || ref === void 0 ? void 0 : ref.length) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    style: {
                                        gap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                                            symbol: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.selected[0].split("#")[0]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.selected[0].split("#")[0]
                                        })
                                    ]
                                })
                            }),
                            (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref1 = selectedStockFilter.selected) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    style: {
                                        gap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StockCount, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "13px",
                                                color: color/* default.primary */.Z.primary,
                                                children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref2 = selectedStockFilter.selected) === null || ref2 === void 0 ? void 0 : ref2.length
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            children: "Stocks"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock && // @ts-expect-error
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        ml: "12px",
                        children: "All Stocks"
                    }),
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        // @ts-expect-error
                        ml: "12px",
                        style: {
                            maxWidth: 87
                        },
                        ellipsis: true,
                        children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.watchlistName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/chevron-down.svg",
                        id: "rt-filter-chevron-down"
                    })
                ]
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_DropdownContent, {
                    isMarketOpen: isMarketOpen,
                    onClosePopover: function() {
                        return setVisible(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var ActionControl_StocksFilter = (StocksFilter);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/index.tsx



 // Implemented on next phase





var ActionControl = function(param) {
    var isMarketOpen = param.isMarketOpen, _hideStockFilter = param.hideStockFilter, hideStockFilter = _hideStockFilter === void 0 ? false : _hideStockFilter, _playAlignRight = param.playAlignRight, playAlignRight = _playAlignRight === void 0 ? false : _playAlignRight;
    var stockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var isLeftPlayVisible = (0,react.useMemo)(function() {
        return isMarketOpen && !playAlignRight;
    }, [
        isMarketOpen,
        playAlignRight
    ]);
    var isRightPlayVisible = (0,react.useMemo)(function() {
        return isMarketOpen && playAlignRight;
    }, [
        isMarketOpen,
        playAlignRight
    ]);
    var showAdvancedFilter = (0,react.useMemo)(function() {
        if (isMarketOpen) return true;
        if (!isMarketOpen && stockFilter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && stockFilter.selected.length === 1) {
            return true;
        }
        return false;
    }, [
        stockFilter,
        isMarketOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionControlWrapper, {
        children: [
            isLeftPlayVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_PausePlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                style: {
                    gap: 8
                },
                justify: "end",
                children: [
                    isRightPlayVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_PausePlay, {}),
                    !hideStockFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_StocksFilter, {
                        isMarketOpen: isMarketOpen
                    }),
                    showAdvancedFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_AdvancedFilter, {
                        isMarketOpen: isMarketOpen
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RunningTrade_ActionControl = (ActionControl);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/useRunningTradeCustomFilter.ts


var useRunningTradeCustomFilter = function(isUseCustomFilter) {
    var getFilter = function() {
        return store/* useFilterStore.getState */.r.getState().filter;
    };
    var getStockFilter = function() {
        return store/* useFilterStore.getState */.r.getState().stocksFilter;
    };
    var runningTradeFilter = function(items) {
        if (!isUseCustomFilter) return items;
        var filter = getFilter();
        var stockFilter = getStockFilter();
        return filterRunningTrade(items, filter, stockFilter);
    };
    return {
        runningTradeFilter: runningTradeFilter
    };
};
/* harmony default export */ var RunningTrade_useRunningTradeCustomFilter = (useRunningTradeCustomFilter);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/index.tsx























var tableIdentifierClassName = "table-scroller";
function RunningTrade(param) {
    var _runningTradeKey = param.runningTradeKey, runningTradeKey = _runningTradeKey === void 0 ? "widget" : _runningTradeKey, className = param.className, _minDataLength = param.minDataLength, minDataLength = _minDataLength === void 0 ? 10 : _minDataLength, isPro = param.isPro, hideHeader = param.hideHeader, _hideCode = param.hideCode, hideCode = _hideCode === void 0 ? false : _hideCode, _hideStockFilter = param.hideStockFilter, hideStockFilter = _hideStockFilter === void 0 ? false : _hideStockFilter, _playAlignRight = param.playAlignRight, playAlignRight = _playAlignRight === void 0 ? false : _playAlignRight, fullWidth = param.fullWidth, _isVolumeColor = param.isVolumeColor, isVolumeColor = _isVolumeColor === void 0 ? false : _isVolumeColor, _allowInitialData = param.allowInitialData, allowInitialData = _allowInitialData === void 0 ? false : _allowInitialData;
    var ref = (0,react.useState)(false), isOpenMarket = ref[0], setIsOpenMarket = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    // performance issue in BE, so we need to use V1
    // will be updated if BE fixing the V2 version
    var runningTradeVersion = "V2";
    var filter = (0,store/* useFilterStore */.r)(function(s) {
        return s.filter;
    });
    var stocksFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var isPaused = (0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return s.runningTrade.widget.isPaused;
    });
    var onApplyStockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyStockFilter;
    });
    var combinedCustomFilter = (0,react.useMemo)(function() {
        return mapCustomFilter((0,_object_spread/* default */.Z)({}, filter, stocksFilter), allowInitialData ? false : isOpenMarket);
    }, [
        filter,
        stocksFilter,
        isOpenMarket
    ]);
    var wrapperRef = (0,react.useRef)(null);
    var runningTradeFilter = RunningTrade_useRunningTradeCustomFilter(true).runningTradeFilter;
    var ref1 = Datafeed_useRunningTrade(runningTradeKey, runningTradeFilter), isLoading = ref1.isLoading, runningTrade = ref1.runningTrade, setInstanceActive = ref1.setInstanceActive, setInstanceFilter = ref1.setInstanceFilter, setDebounceInstanceFilter = ref1.setDebounceInstanceFilter;
    var ref2 = (0,useDatafeedSocket/* default */.Z)(), datafeedError = ref2.error;
    var ref3 = (0,useRunningTradeInit/* default */.Z)({
        version: runningTradeVersion,
        defaultParams: (0,_object_spread/* default */.Z)({
            sort: "desc",
            order_by: "ORDER_BY_TIME",
            limit: 50
        }, combinedCustomFilter),
        onSuccess: function(data) {
            var ref;
            setInstanceActive(data.is_open_market);
            setIsOpenMarket(data.is_open_market);
            // @ts-ignore
            dispatch(slice/* default.actions.setIsMarketOpen */.ZP.actions.setIsMarketOpen(data.is_open_market));
            if (!data.is_open_market && stocksFilter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && (stocksFilter === null || stocksFilter === void 0 ? void 0 : (ref = stocksFilter.selected) === null || ref === void 0 ? void 0 : ref.length) > 1) {
                onApplyStockFilter({
                    type: types/* StockFilterTypeEnum.AllStock */.d.AllStock,
                    selected: []
                });
            }
        }
    }), runningTradeRes = ref3.runningTradeRes, runningTrades = ref3.runningTrades, isInitiating = ref3.isInitiating, isLoadingMore = ref3.isLoadingMore, hasMore = ref3.hasMore, loadMore = ref3.loadMore, params = ref3.params, setParams = ref3.setParams;
    (0,react.useEffect)(function() {
        if (allowInitialData || !isInitiating && !isOpenMarket) {
            setParams(function(s) {
                return (0,_object_spread/* default */.Z)({
                    sort: s.sort,
                    limit: s.limit,
                    order_by: s.order_by,
                    trade_number: undefined
                }, mapCustomFilter((0,_object_spread/* default */.Z)({}, filter, stocksFilter), allowInitialData ? false : isOpenMarket));
            });
        }
    }, [
        filter,
        stocksFilter,
        allowInitialData
    ]);
    var handleReloadClick = function() {
        window.location.reload();
    };
    var scrollToTop = (0,react.useCallback)(function() {
        // Reset ant table body scroll position back to top
        if (wrapperRef) {
            var scrollableEl = wrapperRef.current.querySelector(".".concat(tableIdentifierClassName));
            if (!scrollableEl) return;
            scrollableEl.scrollTo({
                top: 0
            });
        }
    }, []);
    var handleSetSocketFilter = (0,react.useCallback)(function(symbol) {
        setDebounceInstanceFilter(symbol || "*");
    }, []);
    var handleSetAPIFilter = (0,react.useCallback)(function(symbol) {
        setParams(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                symbol: symbol,
                trade_number: undefined
            });
        });
        scrollToTop();
        setInstanceFilter(symbol);
    }, [
        scrollToTop
    ]);
    var handleTableSort = (0,react.useCallback)(function(field, order) {
        setParams(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                sort: order,
                order_by: field,
                trade_number: undefined
            });
        });
        scrollToTop();
    }, []);
    (0,react.useEffect)(function() {
        setInstanceFilter(runningTrade.filter || "*");
        if (runningTrade.filter !== "" && runningTrade.filter !== "*") {
            handleSetSocketFilter(runningTrade.filter);
            handleSetAPIFilter(runningTrade.filter);
        }
    }, [
        runningTrade.filter
    ]);
    if (!isInitiating && runningTradeRes && runningTradeRes.is_open_market && datafeedError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Failed/* default */.Z, {
            onReloadClick: handleReloadClick
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Box */.xu, {
        id: "running-trade",
        className: className,
        ref: wrapperRef,
        children: [
            !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_Header, {
                children: "Running Trade"
            }),
            isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    overflow: "hidden",
                    height: "calc(100vh - 42px)"
                },
                children: isInitiating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimarySpinner/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_ActionControl, {
                            isMarketOpen: runningTradeRes === null || runningTradeRes === void 0 ? void 0 : runningTradeRes.is_open_market,
                            hideStockFilter: hideStockFilter,
                            playAlignRight: playAlignRight
                        }),
                        runningTradeRes && runningTradeRes.is_open_market ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTradeTable/* default */.Z, {
                            initialData: allowInitialData ? runningTradeRes.running_trade : [],
                            minDataLength: minDataLength,
                            data: runningTrade.data,
                            loading: isLoading,
                            showAction: true,
                            height: "calc(100vh - 133px)",
                            hideCode: hideCode,
                            isPaused: isPaused,
                            isCodeBold: true,
                            isVolumeColor: isVolumeColor
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTradeInitTable/* default */.Z, {
                            id: tableIdentifierClassName,
                            data: runningTrades,
                            showCode: !hideCode,
                            showAction: true,
                            hasMore: hasMore,
                            loadMore: loadMore,
                            isLoadingMore: isLoadingMore,
                            height: "calc(100vh - 102px)",
                            handleTableSort: handleTableSort,
                            defaultSort: {
                                direction: params.sort,
                                key: params.order_by
                            }
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                height: "90vh",
                source: analytics/* SideWidgetAnalytics.RUNNING_TRADE */.Lb.RUNNING_TRADE
            })
        ]
    });
}
/* harmony default export */ var SideWidget_RunningTrade = (RunningTrade);


/***/ }),

/***/ 1014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useClickOutside(callback) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleClickOutside = function(event) {
            var ref1;
            if (ref.current && !((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target)) && callback) {
                callback();
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        callback
    ]);
    return {
        ref: ref
    };
};


/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ })

}]);